import { TooltipOptionInput } from './tooltip-option-input.model';


export class CustomizeToolTipUpdateInput implements ICustomizeToolTipUpdateInput {
    /** The auto-generated id of the customize tool tip master */
    customizeTooltipId!: number;
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The user group name with 255 character limit */
    customizeTooltipName!: string;
    tooltipOption!: TooltipOptionInput[];

    constructor(data?: ICustomizeToolTipUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customizeTooltipId = _data["customizeTooltipId"];
            this.companyDetailsId = _data["companyDetailsId"];
            this.customizeTooltipName = _data["customizeTooltipName"];
            if (Array.isArray(_data["tooltipOption"])) {
                this.tooltipOption = [] as any;
                for (let item of _data["tooltipOption"])
                    this.tooltipOption!.push(TooltipOptionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomizeToolTipUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomizeToolTipUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customizeTooltipId"] = this.customizeTooltipId;
        data["companyDetailsId"] = this.companyDetailsId;
        data["customizeTooltipName"] = this.customizeTooltipName;
        if (Array.isArray(this.tooltipOption)) {
            data["tooltipOption"] = [];
            for (let item of this.tooltipOption)
                data["tooltipOption"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ICustomizeToolTipUpdateInput {
    /** The auto-generated id of the customize tool tip master */
    customizeTooltipId: number;
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The user group name with 255 character limit */
    customizeTooltipName: string;
    tooltipOption: TooltipOptionInput[];
}

